import * as React from 'react'

export interface IMaterialTextareaProps {
  placeholder: string
  disableMaterialPlaceholder?: boolean
  onChange?: (value: string) => void
  value?: any
  required?: boolean
  defaultValue?: any
  rows?: number
  disabled?: boolean
}

export interface IMaterialTextareaState {
  hasValue: boolean
  hasFocus: boolean
  disableMaterialPlaceholder: boolean
}

export class MaterialTextarea extends React.Component<IMaterialTextareaProps, IMaterialTextareaState> {
  componentWillMount() {
    this.setState({
      hasValue: this.props.defaultValue || this.props.value ? true : false,
      hasFocus: false,
      disableMaterialPlaceholder: !!this.props.disableMaterialPlaceholder,
    })
  }

  onChange(e: React.SyntheticEvent<HTMLTextAreaElement>): void {
    const value = e.currentTarget.value
    const hasValue = !!value

    this.setState({ hasValue })

    if (typeof this.props.onChange === 'function') {
      this.props.onChange(value)
    }
  }

  onFocusChange(hasFocus: boolean): void {
    this.setState({ hasFocus })
  }

  render() {
    return (
      <div className={`material-textarea-group ${this.state.hasValue ? 'hasValue' : ''} ${this.state.hasFocus ? 'hasFocus' : ''} ${this.state.disableMaterialPlaceholder ? 'disableMaterialPlaceholder' : ''}`}>
        {this.state.disableMaterialPlaceholder ? null : (<label className="material-input-placeholder">{this.props.placeholder}</label>)}

        <textarea className="form-control material-input"
          disabled={this.props.disabled}
          rows={this.props.rows}
          required={this.props.required}
          defaultValue={this.props.defaultValue}
          value={this.props.value}
          placeholder={this.state.disableMaterialPlaceholder ? this.props.placeholder : null}
          onChange={(e) => this.onChange(e)}
          onFocus={(e) => this.onFocusChange(true)}
          onBlur={(e) => this.onFocusChange(false)}
        />
      </div>
    )
  }
}

export default MaterialTextarea



// WEBPACK FOOTER //
// ./src/app/components/material/MaterialTextarea/index.tsx